module.exports = __webpack_public_path__ + "static/media/shoe5.605bf0b6.jpeg";